// import axios from "axios";
import { handleError } from "../errorServices";
import {
  GETCallHelper,
  POSTCallHelper,
  POSTCallWithFilesHelper,
  DELETECallHelper,
} from "../services.js";
export default {
  // Get Practice
  async loadPractices(context, payload) {
    try {
      const page = typeof payload === "number" ? payload : payload?.page;
      const all = payload && typeof payload === "object" && payload.all === true;
      const params = all ? {} : { paginate: "yes" };
      const response = page
        ? await GETCallHelper("su/practices", params, page)
        : await GETCallHelper("su/practices", params);
      const practices = response?.data?.practices;

      if (Array.isArray(practices)) {
        context.commit("setPractices", {
          data: practices,
          total: practices.length,
          per_page: practices.length || 10,
        });
      } else {
        context.commit(
          "setPractices",
          practices ?? { data: [], total: 0, per_page: 10 }
        );
      }
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },
  // Delete Practice
  async deletePractice(context, payload) {
    try {
      await DELETECallHelper("su/practices/delete/", payload);
      context.commit("deletePractice", payload);
      await context.dispatch("loadPractices", 1);
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },
  // Add Practice
  async addPractice(context, payload) {
    try {
      await POSTCallHelper("su/practices/create", payload);
      await context.dispatch("loadPractices", 1);
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },
  // Assign practice to user
  async assignUserToPractice(context, payload) {
    try {
      await POSTCallHelper("su/practices/assign-to-user", payload);
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },
  // Remove user from practice
  async removeUserFromPractice(context, payload) {
    try {
      await POSTCallHelper("su/practices/revoke-for-user", payload);
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },
  // Get Policies
  async loadPolicies(context, payload) {
    try {
      const page = typeof payload === "number" ? payload : payload?.page;
      const response = page
        ? await GETCallHelper("policies", null, page)
        : await GETCallHelper("policies");
      context.commit("setPolicies", response?.data?.policies ?? []);
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },
  // Add Policy
  async addPolicy(context, payload) {
    try {
      await POSTCallWithFilesHelper("policies/create", payload);
      await context.dispatch("loadPolicies");
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },
  // Delete Policy
  async deletePolicy(context, payload) {
    try {
      await DELETECallHelper("policies/delete/", payload);
      context.commit("deletePolicy", payload);
    } catch (e) {
      handleError(e?.response?.data);
    }
  },
  // Get Users
  async loadUsers(context, payload) {
    try {
      const page = typeof payload === "number" ? payload : payload?.page;
      const response = page
        ? await POSTCallHelper("su/users", {}, page)
        : await POSTCallHelper("su/users", {});
      const users = response?.data?.users ?? {};
      context.commit("setUser", users);
      return users;
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },
  // Add User
  async addUser(context, payload) {
    try {
      const { skipReload = false, ...data } = payload || {};
      await POSTCallHelper("su/users/create", data);
      if (!skipReload) {
        await context.dispatch("loadUsers", 1);
      }
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },
  // Update User
  async updateUser(context, payload) {
    try {
      // POST is used because the API CORS allow-list historically omitted PATCH,
      // which made the browser report a generic "Network Error" on update.
      await POSTCallHelper("su/users/update", payload);
      const page =
        typeof context.state.users?.current_page === "number"
          ? context.state.users.current_page
          : 1;
      await context.dispatch("loadUsers", page);
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },
  // Delete User
  async deleteUser(context, payload) {
    try {
      await DELETECallHelper("su/users/delete/", payload);
      context.commit("deleteUser", payload);
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },
  // Get Roles
  async loadRoles(context, payload) {
    try {
      const params =
        payload && typeof payload === "object" ? payload : undefined;
      const response = await GETCallHelper("su/roles", params);
      const roles = Array.isArray(response?.data?.roles)
        ? response.data.roles
        : [];

      // SA table/pagination expect { data, total, per_page }
      context.commit("setRoles", {
        data: roles,
        total: roles.length,
        per_page: roles.length || 10,
      });

      // Multiselect consumers (MA/RE) expect [{ code, label }]
      const roleOptions = roles
        .map((item) => {
          const rawName = item.name || "";
          const label =
            rawName.charAt(0).toUpperCase() +
            rawName.slice(1).replaceAll("_", " ");
          return { code: item.id, label, name: rawName };
        })
        .filter(
          (item, index, self) =>
            index === self.findIndex((r) => r.code === item.code)
        )
        .filter(
          (item) =>
            !["Admin", "Recruiter", "Manager", "Hq", "Super admin"].includes(
              item.label
            )
        );
      context.commit("setRoleOptions", roleOptions);
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },
  // Add Role
  async addRole(context, payload) {
    try {
      await POSTCallHelper("su/roles/create", payload);
      await context.dispatch("loadRoles");
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },
  // Delete Role
  async deleteRole(context, payload) {
    try {
      await DELETECallHelper("su/roles/delete/", payload);
      context.commit("deleteRole", payload);
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },
  // Assign role to user
  async assignRoleToUser(context, payload) {
    try {
      const { skipReload = false, ...data } = payload || {};
      await POSTCallHelper("su/roles/assign", data);
      if (!skipReload) {
        await context.dispatch("loadRoles");
      }
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },
  // Remove role from user
  async removeRoleFromUser(context, payload) {
    try {
      const { skipReload = false, ...data } = payload || {};
      await POSTCallHelper("su/roles/revoke", data);
      if (!skipReload) {
        await context.dispatch("loadRoles");
      }
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },

  // Get Permissions
  async loadPermissions(context, payload) {
    try {
      const page = typeof payload === "number" ? payload : payload?.page;
      const response = page
        ? await GETCallHelper("su/permissions", null, page)
        : await GETCallHelper("su/permissions");
      const permissions = response?.data?.permissions;

      if (Array.isArray(permissions)) {
        context.commit("setPermissions", {
          data: permissions,
          total: permissions.length,
          per_page: permissions.length || 10,
        });
      } else {
        context.commit(
          "setPermissions",
          permissions ?? { data: [], total: 0, per_page: 10 }
        );
      }
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },
  // Add Permissions
  async addPermission(context, payload) {
    try {
      await POSTCallHelper("su/permissions/create", payload);
      await context.dispatch("loadPermissions", 1);
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },
  // Delete Permissions
  async deletePermission(context, payload) {
    try {
      await DELETECallHelper("su/permissions/delete/", payload);
      context.commit("deletePermissions", payload);
      await context.dispatch("loadPermissions", 1);
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },
  // Assign permission to user
  async assignPermissionToUser(context, payload) {
    try {
      await POSTCallHelper("su/permissions/assign-to-user", payload);
      await context.dispatch("loadPermissions", 1);
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },
  // Remove permission from user
  async removePremissionFromUser(context, payload) {
    try {
      await POSTCallHelper("su/permissions/revoke-for-user", payload);
      await context.dispatch("loadPermissions", 1);
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },
  // Assign permission to role
  async assignPermissionToRole(context, payload) {
    try {
      await POSTCallHelper("su/permissions/assign-to-role", payload);
      await context.dispatch("loadPermissions", 1);
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },
  // Remove permission from role
  async removePermissionFromRole(context, payload) {
    try {
      await POSTCallHelper("su/permissions/revoke-for-role", payload);
      await context.dispatch("loadPermissions", 1);
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },

  // Get Rooms
  async loadRooms(context, payload) {
    try {
      const page = typeof payload === "number" ? payload : payload?.page;
      const response = page
        ? await POSTCallHelper("rooms", {}, page)
        : await POSTCallHelper("rooms", {});
      const rooms = response?.data?.rooms;

      if (Array.isArray(rooms)) {
        context.commit("setRooms", {
          data: rooms,
          total: rooms.length,
          per_page: rooms.length || 10,
        });
      } else {
        context.commit("setRooms", rooms || { data: [], total: 0, per_page: 10 });
      }
    } catch (e) {
      handleError(e?.response?.data);
    }
  },
  // Add Room
  async addRoom(context, payload) {
    try {
      await POSTCallHelper("rooms/create", payload);
      context.dispatch("loadRooms");
    } catch (e) {
      handleError(e?.response?.data);
    }
  },
  // Delete Rooms
  async deleteRoom(context, payload) {
    try {
      await DELETECallHelper("rooms/delete/", payload);
      context.commit("deleteRooms", payload);
    } catch (e) {
      handleError(e?.response?.data);
    }
  },
  // Get Reason
  async loadReasons(context, payload) {
    try {
      const page = typeof payload === "number" ? payload : payload?.page;
      const response = page
        ? await GETCallHelper("reasons", null, page)
        : await GETCallHelper("reasons");
      const reasons = response?.data?.reasons;

      if (Array.isArray(reasons)) {
        context.commit("setReasons", {
          data: reasons,
          total: reasons.length,
          per_page: reasons.length || 10,
        });
      } else {
        context.commit(
          "setReasons",
          reasons ?? { data: [], total: 0, per_page: 10 }
        );
      }
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },
  // Add Reason
  async addReason(context, payload) {
    try {
      await POSTCallHelper("reasons/create", payload);
      await context.dispatch("loadReasons", 1);
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },
  // Delete Reason
  async deleteReason(context, payload) {
    try {
      await DELETECallHelper("reasons/delete/", payload);
      context.commit("deleteReasons", payload);
      await context.dispatch("loadReasons", 1);
    } catch (e) {
      if (e?.response?.data) {
        handleError(e.response.data);
      }
      throw e;
    }
  },
};
